<template>
  <v-snackbar v-model="snackbarOpen" bottom multi-line vertical :timeout="0">
    <v-slide-y-transition mode="out-in">
      <v-layout row justify-space-between align-content-center>
        <v-layout row justify-start align-content-center align-center>
          <p class="d-block ma-0 mr-1">
            {{ text }}
          </p>
        </v-layout>
        <v-btn color="pink" flat class="ma-0" @click="dismiss(id)">
          Close
        </v-btn>
      </v-layout>
    </v-slide-y-transition>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Snackbar",
  computed: {
    snackbarOpen: {
      set: function(open) {
        if (!open) {
          return this.dismiss(this.id);
        }
      },
      get() {
        return this.open;
      }
    },
    ...mapGetters({
      open: "snackbar/open",
      text: "snackbar/text",
      id: "snackbar/id"
    })
  },
  methods: {
    ...mapActions({
      dismiss: "snackbar/dismiss"
    })
  }
};
</script>
